<div class="processing-questionnaire-container">
  <div class="questionnaire-content-header"></div>
  <div class="processing-answered-results">
    <div class="prepare-processing" *ngIf="prepareProcessing; else answeredTemplate">{{ questionnaireContent.prepareProcessing }}</div>
    <ng-template #answeredTemplate>
      <span class="answered-count">{{ answered || 0 }}</span>
      <span class="answered-text">Answered</span>
    </ng-template>
  </div>
  <u-progress-bar
    [value]="(completed / questions) * 100"
    [styles]="{ height: '8px', borderRadius: '8px', width: '560px' }"
  ></u-progress-bar>
  <div class="questionnaire-file">
    <div class="questionnaire-details-file">
      <u-icon [model]="{ type: 'font', value: 'icon-answer' }" [styles]="{ color: 'var(--color-primary)', fontSize: '16px' }"></u-icon>
      <span class="questionnaire-file-name">
        {{ questionnaireContent.requestForProposal }} <span class="name">{{ data.fileName }} </span>.{{ data.extension }}
      </span>
    </div>
    <div class="processing-details-count">
      <span class="text-bolder">{{ completed || 0 }}</span>
      <span class="text-regular">/{{ questions || 0 }}</span>
    </div>
  </div>
</div>
